import * as yup from 'yup';
import type { StringSchema, Schema } from 'yup';
import { createSkipIfNotChangedMethod, StoredValues } from './skipIfNotChanged';

// Установка кастомных сообщений
yup.setLocale({
    mixed: {
        required: 'Обязательное поле',
        default: 'Некорректное значение',
        notType: 'Некорректное значение',
        oneOf: 'Должно быть значение из списка',
    },
    string: {
        email: 'Некорректный email',
        max: 'Значение слишком длинное',
        min: 'Значение слишком короткое',
    },
});

// Кастомные методы
yup.addMethod(yup.mixed, 'skipIfNotChanged', createSkipIfNotChangedMethod());

yup.addMethod(yup.string, 'skipIfNotChanged', createSkipIfNotChangedMethod());

yup.addMethod<StringSchema>(yup.string, 'validateEmail', function (message?: string) {
    return this.matches(
        /^(?=((?:(?:[A-Za-z0-9!#$%&'*+=?^_`{|}~-][.]?(?=([A-Za-z0-9!#$%&'*+=?^_`{|}~-]))*)*[^\s.]|"[A-Za-z0-9!@#$%&'*+=?^_`{|}~.\-\s]*")@{1}))\1(?:(?:([A-Za-z0-9][-]?(?=[A-Za-z0-9]*))*[A-Za-z0-9]+\.)+[A-Za-z]{2,})$/gm,
        {
            message: message || 'Некорректный email',
            name: 'email',
            excludeEmptyString: true,
        },
    );
});

yup.addMethod<StringSchema>(yup.string, 'notRequiredNumber', function (message?: string) {
    return this.test('notRequiredNumber', message || 'Некорректное значение', function (value) {
        return value === undefined || value === '' || !isNaN(parseFloat(value));
    });
});

yup.addMethod<StringSchema>(yup.string, 'fullName', function (message?: string) {
    return this.test('fullName', message || 'Введите ФИО полностью', function (value) {
        return (
            value === undefined ||
            value === '' ||
            /^[а-яё-]{2,}\s[а-яё-]{2,}\s[а-яё-]{2,}(\s[а-яё-]{2,})?$/i.test(value.trim())
        );
    });
});

yup.addMethod<StringSchema>(yup.string, 'mobilePhone', function (message?: string) {
    return this.test('mobilePhone', message || 'Некорректный номер', function (value) {
        const clean = value?.replace(/\D/g, '') || '';
        return value === undefined || value === '' || (clean.length === 11 && /^7[345689]\d{9}$/.test(clean));
    });
});

/** Российские мобильные номера телефонов */
yup.addMethod<StringSchema>(yup.string, 'isRussianMobilePhone', function (message?: string) {
    return this.test('isRussianMobilePhone', message || 'Некорректный мобильный номер', function (value) {
        const clean = value?.replace(/\D/g, '') || '';
        return !clean || (typeof clean === 'string' && /^79\d{9}/.test(clean));
    });
});

// Расширение типов
declare module 'yup' {
    interface StringSchema {
        validateEmail(message?: string): this;
        notRequiredNumber(message?: string): this;
        fullName(message?: string): this;
        mobilePhone(message?: string): this;
        isRussianMobilePhone(message?: string): this;
        skipIfNotChanged(storedValues: StoredValues, chain: Schema): this;
    }

    interface MixedSchema {
        skipIfNotChanged(storedValues: StoredValues, chain: Schema): this;
    }
}

export default yup;
